import { useState } from "react";
import Joi from "joi-browser";

const keyValuePairSchema = {
  key: Joi.string().required().label("Key"),
  value: Joi.string().required().label("Value"),
};
export default function useKeyValuePairForm(
  keyValuePair,
  existingKeys,
  originalKey,
) {
  const [formState, setFormState] = useState({
    key: keyValuePair.key ?? "",
    value: keyValuePair.value ?? "",
  });
  const [errors, setErrors] = useState({});

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(keyValuePairSchema);
    const { error } = schema.validate(formState, {
      abortEarly: false,
    });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });

    const isDuplicate = existingKeys.some(
      (k) => k === formState.key && k !== originalKey,
    );
    if (isDuplicate) {
      fieldErrors["key"] = "Key already exists";
    }

    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0;
  };

  return { formState, validate, updateFormState, errors };
}
